import React, { useEffect, useState } from 'react';
import { ApiRequest } from 'GlobalFunctions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ImageUploader from 'elements/ImageUploader';
import ImageViewer from './ImageViewer';

interface ConversationProps {
  conversationId: string;
}

const defaultValues = {
  message_text: '',
  image: '',
  conversation_id: '',
};


export default function Conversation({ conversationId }: ConversationProps) {
  const [messages, setMessages] = useState<any>([]);
  const [formValues, setFormValues] = useState<any>(defaultValues);
  const [files, setFiles] = useState<any>([]);
  const [openImageViewer, setOpenImageViewer] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const getMessages = async () => {
    await ApiRequest({
      url: `/messages`,
      method: 'GET',
      query: {
         conversation_id: conversationId
      },
      setResponse: (response: any) => {
        setMessages(response.messages);
      },
    });
  }

  const markAsViewed = async () => {
    await ApiRequest({
      url: '/messages/markAsViewed',
      method: 'POST',
      body: {
        conversation_id: conversationId,
      },
      setResponse : (response: any) => {
        console.log(response);
      }
    });
  };

  useEffect(() => {
    getMessages();
    markAsViewed();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId]);

  useEffect(() => {
    const conversationContainer = document.querySelector('.conversation_container');
    if (!conversationContainer) return;

    // Limpiar el timer si el componente se desmonta antes de que ejecute
    const timer = setTimeout(() => {
      conversationContainer.scrollTop = (conversationContainer as HTMLElement).scrollHeight;
    }, 100);

    return () => clearTimeout(timer);
  }, [messages]);

  const handleSendMessage = async () => {
    if (formValues.message_text.trim() === '' && files.length === 0) return;

    // Crear un nuevo objeto en lugar de mutar el estado directamente
    const messageData = { ...formValues, conversation_id: conversationId };

    const body = new FormData();
    body.append('formValues', JSON.stringify(messageData));
    if (files) {
      body.append('image', files);
    }

    await ApiRequest({
      url: '/messages/send',
      method: 'POST',
      formData: true,
      body: body,
      setResponse: (response: any) => {
        if (response.status === 'success') {
          getMessages();
          setFormValues(defaultValues);
          setFiles([]);
        }
      },
    });
  };

  return (
    <>
    <div className='conversation_container'>
        {messages.filter((m: any) => !m.message_text?.startsWith('[AUTO_PLACEHOLDER]')).map((message: any, index: any) => (
          <div
            key={index}
            className={message.is_owner ? 'message_container_owner' : 'message_container_other'}
          >
            <div className='message_bubble'>

              {message.image &&
                <img
                  src={message.image}
                  alt=""
                  className='message_image'
                  onClick={() => {
                    setSelectedImage(message.image);
                    setOpenImageViewer(true);
                  }}
                />
              }

              {message.message_text}

              <div className='message_footer'>
                <div className='message_date'>
                  {message.sent_at}
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
    <div className='message_input_container'>
      <ImageUploader 
          className="message_image_uploader"
          image={formValues.image}
          setImage={(newImage) => setFormValues({ ...formValues, image: newImage })}
          setFiles={setFiles} 
          label=""
      />
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Escribe un mensaje..."
        value={formValues.message_text}
        onChange={(e) => setFormValues({ ...formValues, message_text: e.target.value })}
        style={{ marginLeft: '10px' }}
      />
      <Button variant="contained" color="primary" onClick={handleSendMessage} style={{ marginLeft: '10px' }}>
        Enviar
      </Button>
    </div>
    <ImageViewer
      open={openImageViewer}
      imageSrc={selectedImage}
      onClose={() => setOpenImageViewer(false)}
    />
    </>
  );
}
